export const getTicketAssignedTemplate = (supportName, ticketId, companyName, ticketLink) => `
<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<style>
  body { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; background-color: #f4f4f4; margin: 0; padding: 0; }
  .email-container { max-width: 600px; margin: 20px auto; background: white; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.05); }
  .header { background-color: #90c740; padding: 24px; text-align: center; }
  .header h1 { margin: 0; color: white; font-size: 24px; font-weight: 600; }
  .content { padding: 32px; color: #333; line-height: 1.6; }
  .content h2 { margin-top: 0; color: #2c3e50; font-size: 20px; }
  .details-box { background: #f8fafc; padding: 20px; border-left: 4px solid #90c740; margin: 24px 0; border-radius: 4px; }
  .details-item { margin-bottom: 8px; }
  .details-label { font-weight: bold; color: #555; width: 100px; display: inline-block; }
  .button-container { text-align: center; margin-top: 32px; }
  .button { display: inline-block; background-color: #90c740; color: white !important; padding: 14px 28px; text-decoration: none; border-radius: 6px; font-weight: bold; font-size: 16px; transition: background-color 0.3s; }
  .button:hover { background-color: #7ebd2e; }
  .footer { background-color: #f1f1f1; padding: 20px; text-align: center; font-size: 12px; color: #888; border-top: 1px solid #e1e1e1; }
</style>
</head>
<body>
  <div class="email-container">
    <div class="header">
      <h1>New Ticket Assignment</h1>
    </div>
    <div class="content">
      <h2>Hello ${supportName},</h2>
      <p>You have been assigned to a new support ticket. Please review the details below and take necessary action.</p>
      
      <div class="details-box">
        <div class="details-item">
          <span class="details-label">Ticket ID:</span> 
          <span>#${ticketId}</span>
        </div>
        <div class="details-item">
          <span class="details-label">Company:</span> 
          <span>${companyName}</span>
        </div>
      </div>
      
      <p>Click the button below to view the full ticket details and respond:</p>
      
      <div class="button-container">
        <a href="${ticketLink}" class="button">View Ticket</a>
      </div>
    </div>
    <div class="footer">
      <p>&copy; ${new Date().getFullYear()} ATRAQ. All rights reserved.</p>
      <p>This is an automated message, please do not reply.</p>
    </div>
  </div>
</body>
</html>
`;
